import React from 'react'

const ChangePassword = () => {

    return (
        <>
            <div className='component__modal_window_homeLoan component__settings component__popCSS'>
                <div className='component__mwBody component__settings'>
                    <div className='pageComponent change_password'>
                        <ul className='tabs__maintabs tabs__settings'>
                            <li className='pageComponent component__settings'>Opt out Dealer Response</li>
                            <li className='pageComponent component__settings'>Settings for My Leads</li>
                            <li className='pageComponent component__settings'>Change Password</li>
                        </ul>
                        <div className='pageComponent dashboard__content'>
                            <div className='dashboard__content'>
                                <h4>Change Password</h4>
                                <ul className='dashboard__checkboxlist'>
                                    <li>
                                        <div>
                                            <div className='undefinedContainer'>
                                                <div>
                                                    <span style={{ paddingLeft: "5px", marginRight:"10px" }}>New Password<b style={{color:"red"}}>*</b> </span>
                                                    <input style={{ marginBottom:"10px", height:"20px", fontSize: "12px" }} type="text" placeholder='new password' />
                                                </div>
                                                <div>
                                                    <span style={{ paddingLeft: "5px", marginRight:"10px" }}>Confirm Password<b style={{color:"red"}}>*</b> </span>
                                                    <input style={{ marginBottom:"10px", height:"20px", fontSize: "12px" }} type="text" placeholder='confirm new password' />
                                                </div>
                                            </div>
                                        </div>
                                    </li>
                                </ul>
                                <div className='dashboard__buttonWrapper' style={{ display: "flex", marginTop: "20px" }}>
                                    <div className='dashboard__ngdialogButtonPrimary dashboard__ngdialogButton' style={{ width: '35%', marginRight: "10%", borderRadius:"0px", textAlign:"center", display:"flex", justifyContent:"center", alignItems:"center", height:"50px"}}>
                                        <span><input type="button" value="SavePassword" /></span>
                                    </div>
                                    <div className='dashboard__ngdialogButtonSecondary dashboard__ngdialogButton' style={{ width: '35%', borderRadius:"0px", textAlign:"center", display:"flex", justifyContent:"center", alignItems:"center", height:"50px" }}>
                                        <span><input type="button" value="Cancel" /></span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default ChangePassword